/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Managed collection type enumeration.
 */
export type CollectionKind = typeof CollectionKind[keyof typeof CollectionKind];


export const CollectionKind = {
  category: 'category',
  banner: 'banner',
  subcategory: 'subcategory',
  editorial: 'editorial',
  ranking: 'ranking',
  author: 'author',
  lector: 'lector',
  publisher: 'publisher',
  series: 'series',
  tag: 'tag',
  emotion: 'emotion',
  personal: 'personal',
} as const;
